module.exports = __webpack_public_path__ + "img/060_Erde_Mond_thb.7373f8af.jpg";